var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"sidebar-banner",attrs:{"href":"https://vk.com/share.php?url=https://проверить-уникальность.рф&title=Проверка-уникальности.рф. Бесплатная проверка уникальности текста. Все системы в одном месте"}},[_c('img',{attrs:{"src":"/assets/site/images/sidebar-banner.png"}})])
}]

export { render, staticRenderFns }